import {useState} from "react";
import {UseQuery, UseQueryStateResult} from "@reduxjs/toolkit/dist/query/react/buildHooks";
import {firstPage, PageQuery} from "@tracabois/utils";

export const usePageQuery = (useQuery: UseQuery<any>) => {
    const [pageQuery, setPageQuery] = useState<PageQuery>({pagination: firstPage})
    const {data, error, isLoading, refetch}: UseQueryStateResult<any, any> = useQuery(pageQuery)
    return {setPageQuery, data, error, isLoading, refetch};
}
